getUserNodeInfoVideoMediaData